import store from "@/store/store";
import { bootstrapApp, initializeSessionFlags } from "@/app-bootstrap";

const initializeProductionSession = async () => {
	await store.dispatch("user/authenticate");

	await Promise.all([store.dispatch("environment/load")]);

	if (
		store.getters["environment/isProductionEnvironment"] &&
		"serviceWorker" in navigator
	) {
		navigator.serviceWorker.register(window.origin + "/service-worker.js");
	}

	await store.dispatch("settings/initiate");
};

void bootstrapApp(initializeProductionSession);
initializeSessionFlags();
